var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.047,
    height: 15.77,
    viewBox: "0 0 21.047 15.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_464",
    "data-name": "Union 464",
    d: "M11.538,14.77a4.31,4.31,0,0,1-4.307-4.308V8H2.1l2.026,2.027a.615.615,0,0,1-.87.87L.18,7.82a.616.616,0,0,1-.049-.815l0,0,.007-.008.005-.006,0,0q.018-.02.037-.039L3.257,3.873a.615.615,0,0,1,.87.87L2.1,6.769h9.591a.616.616,0,0,1,0,1.231H8.462v2.462a3.078,3.078,0,0,0,3.076,3.077h4.154a3.079,3.079,0,0,0,3.077-3.077V4.307A3.079,3.079,0,0,0,15.692,1.23H11.538A3.079,3.079,0,0,0,8.462,4.307v.616a.616.616,0,0,1-1.231,0V4.307A4.31,4.31,0,0,1,11.538,0h4.154A4.309,4.309,0,0,1,20,4.307v6.154a4.31,4.31,0,0,1-4.307,4.308Z",
    transform: "translate(20.5 15.27) rotate(180)",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.f57c5326742b80647efe7919242de73b.svg";
export { ForwardRef as ReactComponent };